import CityPlacesSlider from './components/CityPlacesSlider.vue';
import InitLazyComponent from 'Main/modules/InitLazyComponent';

const cityPlacesSliders = document.querySelectorAll(
  '.vue-city-place-type-carousel'
);
const initLazyComponent = new InitLazyComponent({
  selectors: cityPlacesSliders,
  components: { CityPlacesSlider },
  template: '<CityPlacesSlider />',
});

initLazyComponent.init();
